/// <reference path="../../../typings/browser.d.ts" />
/// <reference path="../../../customtypings/selectize/selectize.d.ts" />

namespace Application.Controllers {
    'use strict';

    export interface ISIMDataModalScope extends ng.IScope {
        title: string;
        sim: Models.ISIM;
        inputAmount: number;
        currentRemaining: number;
        selectedDataUnit: string;
        selectedOperation: string;
        modalClose: () => void;
        modalSave: () => void;
        loadSelectize: () => void;
        saveButtonLabel: string;
    }

    /**
     * SIMDataModalController class
     */
    export class SIMDataModalController {
        public static templateURL: string = "decorators/modals/sim-data-modal.html";
        public static ID: string = "#id-sim-data-modal";
        public static $name: string = "sIMDataModalController";
        public static $inject: string[] = ['$scope', 'close', '$timeout', 'title', 'sim', 'currentRemaining'];

        private scope: ISIMDataModalScope;
        private close: (parameters: ngModal.ICloseParameters) => void;
        private $timeout: ng.ITimeoutService;

        private selectizeForDataUnit: Selectize.IApi<string, string>;
        private selectizeForOperation: Selectize.IApi<string, string>;
        private datePicker: UIkit.DatePicker;
        private dataUnitOptions: Common.ISelectizeStringString[] = [
            {
                value: 'MB',
                string: 'MB',
            }, {
                value: 'GB',
                string: 'GB',
            }];
        private operationOptions: Common.ISelectizeStringString[] = [
            {
                value: 'ADD',
                string: 'Add',
            }, {
                value: 'SET',
                string: 'Set',
            }];

        /**
         * Constructor
         */
        constructor($scope: ISIMDataModalScope,
                    close: (parameters: ngModal.ICloseParameters) => void,
                    $timeout: ng.ITimeoutService,
                    title: string,
                    sim: Models.ISIM,
                    currentRemaining: number) {
            $timeout(() => {
                window.altair_admin_common_init();
                window.altair_forms_validation();
            }, 500);

            this.scope = $scope;
            this.scope.title = title;
            this.scope.sim = sim;
            this.scope.currentRemaining = currentRemaining;
            this.close = close;
            this.$timeout = $timeout;

            this.scope.loadSelectize = (): void => {
                this.loadSelectizeForDataUnit();
                this.loadSelectizeForOperation();
                this.loadDatePicker();
            };

            this.scope.modalClose = (): void => {
                this.close(undefined);
            };

            this.scope.modalSave = (): void => {
                if (this.scope.inputAmount && this.scope.inputAmount !== undefined && this.scope.inputAmount >= 0) {
                    // data amount must be stored as bytes
                    if (this.scope.selectedDataUnit === 'GB')
                        this.scope.inputAmount *= Math.pow(1024, 3);
                    else if (this.scope.selectedDataUnit === 'MB')
                        this.scope.inputAmount *= Math.pow(1024, 2);
                    this.scope.inputAmount = Math.round(this.scope.inputAmount);

                    let selectedDateArray: string[] = $('#operation-date-picker').val().split(".");
                    let selectedYear: number = parseInt(selectedDateArray[2], 10);
                    let selectedMonth: number = parseInt(selectedDateArray[1], 10) - 1;
                    let selectedDay: number = parseInt(selectedDateArray[0], 10);
                    let selectedDate: Date;
                    let now: Date = new Date();
                    if (selectedYear === now.getFullYear() && selectedMonth === now.getMonth() && selectedDay === now.getDate()) {
                        // if the selected date is the current one, we get the whole current date (including the time)
                        selectedDate = now;
                    } else {
                        // if the user has changed the date, we get the 00:00:00 time)
                        selectedDate = new Date(selectedYear, selectedMonth, selectedDay);
                        // if the user has entered an invalid date, we get the current date
                        if (isNaN(selectedDate.getTime()))
                            selectedDate = now;
                    }
                    this.close([this.scope.inputAmount, this.scope.selectedOperation, selectedDate]);
                }
            };
        }

        private loadSelectizeForDataUnit(): void {
            if (this.selectizeForDataUnit !== undefined)
                this.selectizeForDataUnit.destroy();
            this.scope.selectedDataUnit = this.dataUnitOptions[0].value;
            let self: Controllers.SIMDataModalController = this;
            let $select: JQuery = $('#select_data_unit')
                .selectize({
                    labelField: 'string',
                    valueField: 'value',
                    maxItems: 1,
                    onChange: (dataUnit: string): void => {
                        for (let i: number = 0; i < self.dataUnitOptions.length; i++)
                            if (self.dataUnitOptions[i].value === dataUnit)
                                self.$timeout(() => {
                                    self.scope.selectedDataUnit = self.dataUnitOptions[i].value;
                                });
                    },
                    options: self.dataUnitOptions,
                });
            this.selectizeForDataUnit = $select[0].selectize;
            if (this.scope.selectedDataUnit)
                this.selectizeForDataUnit.setValue(this.scope.selectedDataUnit);
        }

        private loadSelectizeForOperation(): void {
            if (this.selectizeForOperation !== undefined)
                this.selectizeForOperation.destroy();
            this.scope.selectedOperation = this.operationOptions[1].value;
            let self: Controllers.SIMDataModalController = this;
            let $select: JQuery = $('#select_opperation')
                .selectize({
                    labelField: 'string',
                    valueField: 'value',
                    maxItems: 1,
                    onChange: (operation: string): void => {
                        for (let i: number = 0; i < self.operationOptions.length; i++)
                            if (self.operationOptions[i].value === operation)
                                self.$timeout(() => {
                                    self.scope.selectedOperation = self.operationOptions[i].value;
                                });
                        this.scope.saveButtonLabel = operation;
                    },
                    options: self.operationOptions,
                });
            this.selectizeForOperation = $select[0].selectize;
            if (this.scope.selectedOperation)
                this.selectizeForOperation.setValue(this.scope.selectedOperation);
        }

        private loadDatePicker(): void {
            let datePickerElement: JQuery = $('#operation-date-picker');
            let now: Date = new Date();
            let nowDay: string = now.getDate() < 10 ? '0' + now.getDate() : now.getDate().toString();
            let nowMonth: string = (now.getMonth() + 1) < 10 ? '0' + (now.getMonth() + 1) : (now.getMonth() + 1).toString();
            let nowStr: string = nowDay + '.' + nowMonth + '.' + now.getFullYear();
            datePickerElement.val(nowStr);
            this.datePicker = UIkit.datepicker(datePickerElement, {format: 'DD.MM.YYYY', maxDate: 0});
        }
    }
}